import { render } from "./AssignTesters.vue?vue&type=template&id=48b6594e&scoped=true"
import script from "./AssignTesters.vue?vue&type=script&lang=js"
export * from "./AssignTesters.vue?vue&type=script&lang=js"

import "./AssignTesters.vue?vue&type=style&index=0&id=48b6594e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48b6594e"

export default script